@if (initialized && dto) {
    <div class="grid">
        <!-- Status Cards -->
        <div class="col-12">
            <div class="grid">
                <div class="col-12 md:col-3">
                    <div class="card surface-50 text-center">
                        <div class="text-4xl font-bold text-primary mb-2">
                            <i class="fa-regular fa-folder-open"></i>
                        </div>
                        <div class="text-lg font-medium">{{ dto.name }}</div>
                        <div class="text-sm text-600">Project Name</div>
                    </div>
                </div>
                <div class="col-12 md:col-3">
                    <div class="card surface-50 text-center">
                        <div class="text-4xl font-bold text-blue-500 mb-2">
                            @switch (dto.status) {
                                @case (0) { <i class="fa-regular fa-pencil"></i> }
                                @case (1) { <i class="fa-regular fa-upload"></i> }
                                @case (2) { <i class="fa-regular fa-spinner fa-spin"></i> }
                                @case (3) { <i class="fa-regular fa-check-circle"></i> }
                                @case (4) { <i class="fa-regular fa-sitemap"></i> }
                                @case (5) { <i class="fa-regular fa-flag-checkered"></i> }
                                @case (6) { <i class="fa-regular fa-exclamation-triangle"></i> }
                            }
                        </div>
                        <div class="text-lg font-medium">
                            @switch (dto.status) {
                                @case (0) { Draft }
                                @case (1) { Uploading }
                                @case (2) { Analyzing }
                                @case (3) { Analyzed }
                                @case (4) { Modeling }
                                @case (5) { Completed }
                                @case (6) { Error }
                            }
                        </div>
                        <div class="text-sm text-600">Status</div>
                    </div>
                </div>
                <div class="col-12 md:col-3">
                    <div class="card surface-50 text-center">
                        <div class="text-4xl font-bold text-green-500 mb-2">
                            <i class="fa-regular fa-file-alt"></i>
                        </div>
                        <div class="text-lg font-medium">-</div>
                        <div class="text-sm text-600">Source Files</div>
                    </div>
                </div>
                <div class="col-12 md:col-3">
                    <div class="card surface-50 text-center">
                        <div class="text-4xl font-bold text-orange-500 mb-2">
                            <i class="fa-regular fa-chart-bar"></i>
                        </div>
                        <div class="text-lg font-medium">-</div>
                        <div class="text-sm text-600">Quality Score</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Project Details -->
        <div class="col-12 lg:col-6">
            <mvs-widget
                    *ngIf="projectDataWidget"
                    [widgetData]="projectDataWidget"
            ></mvs-widget>
        </div>

        <!-- Quality Score Widget -->
        <div class="col-12 lg:col-6">
            <div class="card">
                <h5 class="mb-3">Quality Overview</h5>
                @if (latestAnalysisResultId) {
                    <ea-quality-score-widget
                            [analysisResultId]="latestAnalysisResultId"
                    ></ea-quality-score-widget>
                } @else {
                    <div class="flex flex-column align-items-center justify-content-center p-4 text-center surface-100 border-round">
                        <i class="fa-regular fa-chart-bar text-3xl text-400 mb-2"></i>
                        <span class="text-600">Run analysis to view quality score</span>
                    </div>
                }
            </div>
        </div>

        <!-- Recent Files -->
        <div class="col-12 lg:col-6">
            <mvs-widget
                    *ngIf="recentFilesWidget"
                    [widgetData]="recentFilesWidget"
            ></mvs-widget>
        </div>

        <!-- Recent Analysis -->
        <div class="col-12 lg:col-6">
            <mvs-widget
                    *ngIf="recentAnalysisWidget"
                    [widgetData]="recentAnalysisWidget"
            ></mvs-widget>
        </div>
    </div>
}
